import { ReactNode } from 'react';

import { isSSG } from 'modules/common/utils/isSSG';

import { Placeholder } from '../Placeholder';

export interface NoSSRGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export const NoSSRGuard = ({ children, fallback = null }: NoSSRGuardProps) => {
  return (
    <Placeholder hasPlaceholder={isSSG()} placeholder={fallback}>
      {children}
    </Placeholder>
  );
};
